import { useContext, useEffect, useState } from "react";
import "./RequestBalanceHome.css";
import SelectedPackageDetailCard from "../SelectedPackageDetailCard/SelectedPackageDetailCard";
import AppContext from "../../AppContext";
import Form from "../Form/Form";
import Popup from "../Popup/Popup";
import ProductDetail from "../ProductDetail/ProductDetail";

import { REQUEST_BALANCE_HOME } from "../../constants/callTrackingConstants";

import whatsAppIcon from "../../assets/whatsAppIcon.svg";
import disabledWhatsAppIcon from "../../assets/disabledWhatsAppIcon.svg";
import USAFlag from '../../assets/unitedStatesFlag.png';

import { getWhatsAppLink } from "../../services/whatsAppService";

const RequestBalanceHome = () => {
  const [disabledButton, setDisabledButton] = useState(false);

  const {
    products,
    selectedProduct,
    setSelectedProduct,
    isVisiblePopUpDetails,
    setIsVisiblePopUpDetails,
    doCallTracking,
    errorProduct,
    number,
    offerAuxId,
    offerId,
    sessionId,
    msisdn,
  } = useContext(AppContext);

  const whatsAppRequest = async () => {
    if (selectedProduct && !disabledButton) {
      setDisabledButton(true);
      doCallTracking(
        `${REQUEST_BALANCE_HOME.WHATSAPP_BUTTON.elementName}${selectedProduct.pkgType}_POR_WHATSAPP_USA`,
        `${REQUEST_BALANCE_HOME.WHATSAPP_BUTTON.elementLocation}${selectedProduct.pkgType}`,
        number
      );

      try {
        const response = await getWhatsAppLink(
          sessionId,
          offerId,
          offerAuxId,
          selectedProduct.pkgType,
          msisdn
        );

        if (response) {
          const { offerUrl } = response;
          if (offerUrl) {
            window.location.href = offerUrl;
          } else {
            setDisabledButton(false);
          }
        }
      } catch (error) {
        console.log(error);
        setDisabledButton(false);
      }
    }
  };

  useEffect(() => {
    doCallTracking(
      `${REQUEST_BALANCE_HOME.IMPRESION.elementName}`,
      REQUEST_BALANCE_HOME.IMPRESION.elementLocation,
      number
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="request__balance__home__container">
      <div className="request__balance__home__content">
        <h1 className="title__home title__margin">
          Pide datos y paquetes a tus conocidos o familiares en Estados Unidos
          <img alt="usa-flag" className="title__emoji" src={USAFlag} />
        </h1>
        <h1 className="title__home">Selecciona un producto</h1>
        <div className="container__card__products">
          {products &&
            products.sort((a, b) => b.amount - a.amount).map((item) => {
              return (
                <SelectedPackageDetailCard
                  key={item.productId}
                  product={item}
                  selectedProduct={selectedProduct}
                  setSelectedProduct={setSelectedProduct}
                  setIsVisiblePopUpDetails={setIsVisiblePopUpDetails}
                />
              );
            })}
          {errorProduct && (
            <p className="select__error__product">{errorProduct}</p>
          )}
        </div>
        {false && <Form />}
        <button
          disabled={!selectedProduct && disabledButton}
          className={`${
            selectedProduct && !disabledButton
              ? "whatsapp__button"
              : "whatsapp__button_disabled"
          }`}
          onClick={whatsAppRequest}
        >
          Pedir por WhatsApp
          <img
            alt="whatsapp-icon"
            className="whatsapp-icon"
            src={
              selectedProduct && !disabledButton
                ? whatsAppIcon
                : disabledWhatsAppIcon
            }
          />
        </button>
      </div>
      {isVisiblePopUpDetails && (
        <Popup
          setIsVisiblePopUp={setIsVisiblePopUpDetails}
          callTrackingConstants={{}}
        >
          {selectedProduct && <ProductDetail product={selectedProduct} />}
        </Popup>
      )}
    </div>
  );
};

export default RequestBalanceHome;
